import styled from 'styled-components';
import { PropertyCardHomeDetailsMixin } from '../../mixins/components/PropertyCardHomeDetailsMixin';

// Using a span so text truncation by PropertyCard.DataArea works properly.
export var StyledPropertyCardHomeDetails = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledPropertyCardHomeDetails",
  componentId: "c11n-8-99-3__sc-1xo68zc-0"
})(["", ""], PropertyCardHomeDetailsMixin);